<div class="container-fluid">
  <div>
    <div class="row margin-top-8">
      <div class="header" *ngIf="!isFitting">
        {{editing ? ('bikeshop.service_types.edit_service' | translate) : ('bikeshop.service_types.add_service' | translate)}}
      </div>
      <div class="header" *ngIf="isFitting">
        {{editing ? ('bikeshop.service_types.edit_fitting' | translate) : ('bikeshop.service_types.add_fitting' | translate)}}
      </div>
    </div>
    <ng-template></ng-template>
    <div class="row margin-top-8 info-container content">
      <div class="col-md-12">
        <div id="sctServiceTypeManagement">
          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{ 'bikeshop.service_types.category' | translate }}
            </div>
            <div class="col-md-8 value">
              <p-dropdown [options]="categoryOptions" [ngModel]="serviceType.GroupName"
                          placeholder="e.g. Services"
                          [editable]="true" optionLabel="label" (onChange)="updateGroupName($event)">
              </p-dropdown>
            </div>
          </div>


          <div *ngIf="serviceType.ID === undefined">
            <hr />

            <div class="row margin-top-16">
              <div class="col-md-12">
                <div class="sub-header">{{ 'bikeshop.service_types.linked_skus' | translate }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 label margin-top-0">
                <small>{{ 'bikeshop.service_types.linked_skus_message' | translate }}</small>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label"
                   [ngClass]="{'red bold': serviceType.Cost === null || serviceType.Cost === undefined || serviceType.Cost.length === 0}">
                *{{ 'bikeshop.service_types.link_product' | translate }}:
              </div>
              <div class="col-md-8">
                <p-autoComplete [(ngModel)]="newSku" field="SKU" [suggestions]="searchResult"
                                placeholder="{{
                      'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                        | translate
                    }}" (completeMethod)="searchProducts($event)" (onSelect)="linkSku(newSku)">
                  <ng-template let-product pTemplate="item">
                    <div>
                      <span>{{ product.SKU }} - {{ product.Name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
            <hr />
          </div>


          <div class="row margin-top-8">
            <div class="col-md-4 label"
                 [ngClass]="{'red bold': serviceType.ServiceTypeDescription === undefined || serviceType.ServiceTypeDescription.length === 0}">
              *{{ 'bikeshop.service_types.name' | translate }}
            </div>
            <div class="col-md-8 value">
              <input id="float-input" type="text" pInputText placeholder="e.g. Front Suspension Service"
                     [(ngModel)]="serviceType.ServiceTypeDescription" />
            </div>
          </div>

          <div class="row margin-top-8"
               *ngIf="linkedSKUs.length>0 || (newSku && serviceType.Cost !== null && serviceType.Cost !== undefined && serviceType.Cost !== '')">
            <div class="col-md-4 label">
              {{ 'bikeshop.service_types.override_sku_cost' | translate }}
            </div>
            <div class="col-md-2 value">
              <p-inputSwitch [(ngModel)]="serviceType.OverrideSKUPrice"
                             [ngModelOptions]="{ standalone: true }">
              </p-inputSwitch>
            </div>
            <div class="col-md-6">
              <small>{{ 'bikeshop.service_types.override_sku_cost_info' | translate }}</small>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label"
                 [ngClass]="{'red bold': serviceType.Cost === null || serviceType.Cost === undefined || serviceType.Cost.length === 0}">
              *{{ 'bikeshop.service_types.service_cost' | translate }}
            </div>
            <div class="col-md-2 value">
              <div class="currency-symbol">{{partner.CurrencySymbol}}</div>
              <input id="float-input" type="number" pInputText [(ngModel)]="serviceType.Cost"
                     [disabled]="(linkedSKUs.length > 0 || newSku) && !serviceType.OverrideSKUPrice" />
            </div>
            <div class="col-md-6 value" *ngIf="linkedSKUs.length>0">
              <small>*{{'bikeshop.service_types.service_cost_info' | translate }}</small>
            </div>
          </div>


          <div class="row margin-top-8">
            <div class="col-md-4 label"
                 [ngClass]="{'red bold': duration === undefined || duration.length === 0}">
              *{{ 'bikeshop.service_types.service_duration' | translate }}
            </div>
            <div class="col-md-2 value">
              <p-dropdown [options]="timeOptions" [(ngModel)]="duration" optionLabel="showValue"
                          placeholder="e.g. 1h">
              </p-dropdown>
            </div>
          </div>

          <div *ngIf="serviceType.ID">
            <hr />

            <div class="row margin-top-16">
              <div class="col-md-12">
                <div class="sub-header">{{ 'bikeshop.service_types.linked_skus' | translate }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 label margin-top-0">
                <small>{{ 'bikeshop.service_types.linked_skus_message' | translate }}</small>
              </div>
            </div>


            <div class="row margin-top-8">
              <div class="col-md-4 label"
                   [ngClass]="{'red bold': serviceType.Cost === null || serviceType.Cost === undefined || serviceType.Cost.length === 0}">
                {{ 'bikeshop.service_types.link_product' | translate }}:
              </div>
              <div class="col-md-8">
                <p-autoComplete [(ngModel)]="newSku" field="SKU" [suggestions]="searchResult"
                                placeholder="{{
                    'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                      | translate
                  }}" (completeMethod)="searchProducts($event)" (onSelect)="linkSku(newSku)">
                  <ng-template let-product pTemplate="item">
                    <div>
                      <span>{{ product.SKU }} - {{ product.Name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="linkedSKUs && linkedSKUs.length > 0">
              <div class="col-md-4 label">{{'bikeshop.service_types.linked_products' | translate }}</div>
              <div class="col-md-8">
                <!-- <p-chips [(ngModel)]="linkedSKUs" field="SKU" (onRemove)="unlinkSku($event)"></p-chips> -->
                <div class="chip-container">
                  <div *ngFor="let sku of linkedSKUs" class="chip">
                    <span>{{sku.SKU}}</span><span class="fa fa-times"
                                                  (click)="unlinkSku(sku)"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div>
          <hr />
          <div class="row margin-top-8">
            <div class="col-md-4 label" *ngIf="isFitting">
              {{ 'bikeshop.service_types.is_fitting' | translate }}
            </div>
            <div class="col-md-2 value" *ngIf="isFitting">
              <p-inputSwitch [(ngModel)]="serviceType.IsFitting" [disabled]="true"
                             [ngModelOptions]="{ standalone: true }"
                             (onChange)="checkFitting($event)"></p-inputSwitch>
            </div>
            <div class="col-md-4 label">
              {{ 'bikeshop.service_types.external_booking' | translate }}
            </div>
            <div class="col-md-2 value">
              <p-inputSwitch [(ngModel)]="serviceType.Show" [ngModelOptions]="{ standalone: true }"
                             (onChange)="checkOnlineBooking($event)"></p-inputSwitch>
            </div>
          </div>

          <div class="row margin-top-16">
            <div class="col-md-12">
              <div class="sub-header">{{ 'bikeshop.service_types.online_widget' | translate }}</div>
            </div>
          </div>
          <div class="row margin-top-8">
            <div class="col-md-4 label margin-top-0">
              {{ 'bikeshop.service_types.what_does_this_service_include_widget' | translate }}
            </div>
            <div class="col-md-8 value">
              <quill-editor [(ngModel)]="serviceType.AdditionalInformation" [style]="{'height':'220px'}"
                            [modules]="modules" format="html"
                            placeholder="{{ 'bikeshop.service_types.what_does_this_service_include_extra' | translate}}">
              </quill-editor>
            </div>
          </div>

          <div class="row margin-top-16">
            <div class="col-md-12">
              <div class="sub-header">{{ 'bikeshop.service_types.mobile_app' | translate }}</div>
            </div>
          </div>
          <div class="row margin-top-8">
            <div class="col-md-4 label margin-top-0">
              {{ 'bikeshop.service_types.what_does_this_service_include_app' | translate }}
            </div>
            <div class="col-md-8 value">
              <textarea pInputTextarea [(ngModel)]="serviceType.AdditionalInformationApp" [autoResize]="true"
                        placeholder="{{ 'bikeshop.service_types.what_does_this_service_include_extra' | translate}}"></textarea>
            </div>
          </div>
        </div>


        <ul class="margin-top-16">
          <li class="error" *ngIf="nameError">
            {{ 'bikeshop.service_types.error.please_enter_a_name' | translate }}
          </li>
          <li class="error" *ngIf="costError">
            {{ 'bikeshop.service_types.error.please_enter_a_cost' | translate }}
          </li>
          <li class="error" *ngIf="durationError">
            {{ 'bikeshop.service_types.error.please_enter_a_duration' | translate }}
          </li>
        </ul>

        <div class="margin-top-8 button-container" style="display: flex; justify-content: space-between;">
          <div style="display: flex;">
            <div *ngIf="editing" style="margin-right: 20px;"  id="btnDeleteServiceType">
              <button *ngIf="!deleteLoading" pButton label="{{'bikeshop.general.delete' | translate}}"
                      class="p-button-raised alternate" (click)="delete()" [disabled]="saveLoading"
                      style="width: 200px;"></button>
              <div *ngIf="deleteLoading">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                </p-progressSpinner>
              </div>
            </div>
          </div>
          <button *ngIf="!saveLoading" pButton (click)="checkSave()" class="p-button-raised"
                  label="{{'bikeshop.general.save' | translate}}" [disabled]="deleteLoading"
                  style="width: 200px;"></button>
          <div *ngIf="saveLoading">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                               animationDuration=".5s"></p-progressSpinner>
          </div>
        </div>
      </div>
    </div>


    <div class="row margin-top-8 info-container content" *ngIf="serviceType.ID">
      <div class="col-md-12 bottom">
        <div class="tab_container">
          <div (click)="selectTab(1)" class="tab" [ngClass]="{ 'active-tab': selectedTab === 1 }">
            {{ (isFitting ? 'bikeshop.service_types.fitters' : 'bikeshop.service_types.technicians') | translate }}
          </div>
          <div (click)="selectTab(3)" class="tab" [ngClass]="{ 'active-tab': selectedTab === 3 }">
            {{ 'bikeshop.service_types.check_list' | translate }}
          </div>
          <div (click)="selectTab(4)" class="tab" [ngClass]="{ 'active-tab': selectedTab === 4 }">
            {{ 'bikeshop.service_types.message_template' | translate }}
          </div>
        </div>
        <div *ngIf="selectedTab === 1" class="tab-content">
          <div class="tab-header">
            {{ (isFitting ? 'bikeshop.service_types.select_fitting_staff' : 'bikeshop.service_types.select_staff') | translate }}
          </div>
          <div class="row">
            <div class="col-md-10 sub_header">
              {{ 'bikeshop.service_types.select_all' | translate }}
            </div>
            <div class="col-md-2">
              <p-inputSwitch [(ngModel)]="allTech" (ngModelChange)="toggleAll()"></p-inputSwitch>
            </div>
          </div>
          <div class="list-container">
            <div class="row" *ngFor="let technician of technicians">
              <div class="col-md-10" style="display: flex; align-items: center;">
                <div style="margin-right: 8px">
                  <avatar size="30" name="{{ technician.Firstname + ' ' + technician.Surname }}"
                          profilePhoto="">
                  </avatar>
                </div>
                {{ technician.Firstname }} {{ technician.Surname }}
                {{ technician.IsActive ? "" : "(Inactive)" }}
              </div>
              <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="technician.Enabled"
                               (ngModelChange)="checkTechValidation(technician)"
                               [disabled]="!technician.IsActive"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTab === 2" class="tab-content">
          <div class="tab-header">
            {{ 'bikeshop.service_types.allow_online_bookings_message' | translate }}
          </div>
          <div class="row">
            <div class="col-md-10">Enable online booking</div>
            <div class="col-md-2">
              <p-inputSwitch [(ngModel)]="serviceType.Show"
                             [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTab === 3" class="tab-content">
          <div class="tab-header">
            <div class="row">
              <div class="col-md-8"> {{ 'bikeshop.service_types.checklist_message' | translate }}</div>
              <div class="col-md-2">{{'general.active' | translate}}</div>
              <div class="col-md-2">{{'bikeshop.modal.update_job_card.checklist.mandatory_item' | translate}}</div>
            </div>

          </div>
          <div class="list-container" *ngIf="checklist && checklist.length > 0">
            <div class="row" *ngFor="let item of checklist">
              <div class="col-md-8" [ngStyle]="{ 'color': item.labelColour }">{{ item.description }}</div>
              <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="item.Enabled" [ngModelOptions]="{ standalone: true }"
                               [disabled]="item.mandatoryForAllServices"
                               (ngModelChange)="updateChecklist(item)"></p-inputSwitch>
              </div>
              <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="item.Mandatory" [ngModelOptions]="{ standalone: true }"
                               [disabled]="!item.Enabled"
                               (ngModelChange)="updateMandatoryChecklist(item)"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTab === 4" class="tab-content">
          <div class="tab-header">
            <div class="row">
              <div class="col-md-12"> {{ 'bikeshop.service_types.message_template_desc' | translate }}</div>
            </div>
          </div>
          <app-service-type-message-templates [serviceType]="serviceType"
                                              [partner]="partner"></app-service-type-message-templates>
        </div>
      </div>
    </div>




    <div class="row margin-top-8 info-container content" *ngIf="serviceType.ID && serviceType.IsFitting">
      <div class="col-md-12 bottom">
        <div class="sub-header override-heading">
          {{ 'repairs.fittings.overrides.availability' | translate }}
        </div>
        <div class="tab_container">
          <div (click)="selectOverrideTab(1)" class="tab" [ngClass]="{ 'active-tab': selectedOverrideTab === 1 }">
            {{ 'repairs.fittings.overrides.create' | translate }}
          </div>
          <div (click)="selectOverrideTab(2)" class="tab" [ngClass]="{ 'active-tab': selectedOverrideTab === 2 }">
            {{ 'repairs.fittings.overrides.manage' | translate }}
          </div>
        </div>
        <div *ngIf="selectedOverrideTab === 1" class="tab-content">
          <div class="row" *ngIf="!forSpecificDate">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.specific_day' | translate }}
            </div>
            <div class="col-md-6">
              <p-inputSwitch [(ngModel)]="forSpecificDay"></p-inputSwitch>
            </div>
          </div>
          <div class="row" *ngIf="!forSpecificDay">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.specific_date' | translate }}
            </div>
            <div class="col-md-6">
              <p-inputSwitch [(ngModel)]="forSpecificDate"></p-inputSwitch>
            </div>
          </div>
          <div class="row bottom-space-12" *ngIf="forSpecificDay">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.select_day' | translate }}
            </div>
            <div class="col-md-6">
              <p-dropdown [options]="daysOfWeek" [(ngModel)]="specificDay" optionLabel="label"> </p-dropdown>
            </div>
          </div>
          <div class="row bottom-space-12" *ngIf="forSpecificDate">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.select_date' | translate }}
            </div>
            <div class="col-md-6">
              <p-calendar [(ngModel)]="specificDate" [showButtonBar]="false" [showIcon]="true" [readonlyInput]="true"
                          dateFormat="dd MM yy"  dataType="string"></p-calendar>

            </div>
          </div>

          <div class="row bottom-space-12" *ngIf="forSpecificDate || forSpecificDay">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.start_time' | translate }}
            </div>
            <div class="col-md-6">
              <!--<input type="time" pInputText [(ngModel)]="startTime" />-->
              <hub-datepicker [icon]="'clock'" [(ngModel)]="startTime" [timeOnly]="true" [stepMinute]="1"
                              [required]="true" [dateFormat]="'h:mm tt'"></hub-datepicker>
            </div>
          </div>

          <div class="row bottom-space-12" *ngIf="forSpecificDate || forSpecificDay">
            <div class="col-md-6">
              {{ 'repairs.fittings.overrides.end_time' | translate }}
            </div>
            <div class="col-md-6">
              <!--<input type="time" pInputText [(ngModel)]="endTime" />-->
              <hub-datepicker [icon]="'clock'" [(ngModel)]="endTime" [timeOnly]="true"  [stepMinute]="1"
                              [required]="true" [dateFormat]="'h:mm tt'" ></hub-datepicker>
            </div>
          </div>

          <div class="margin-top-8 button-container" style="display: flex; justify-content: space-between;">
            <div style="display: flex;">

            </div>
            <button *ngIf="!saveLoading" pButton (click)="saveOverride()" class="p-button-raised"
                    label="{{'bikeshop.general.save' | translate}}" [disabled]="deleteLoading"
                    style="width: 200px;"></button>
            <div *ngIf="saveLoading">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                 animationDuration=".5s"></p-progressSpinner>
            </div>
          </div>
        </div>
        <div *ngIf="selectedOverrideTab === 2" class="tab-content">
          <div class="tab-header">
            {{ 'repairs.fittings.overrides.day_overrides' | translate }}
          </div>
          <div class="row">
            <div style="width: -webkit-fill-available;">
              <div class="row" *ngFor="let override of configuredOverrides">
                <div class="row col-md-12" *ngIf="override.forSpecificDay" style="margin-bottom:10px;">
                  <div class="col-md-10" style="display: flex; align-items: center; padding-left: 30px;">
                    {{ 'repairs.fittings.overrides.available_on' | translate }} {{ override.specificDay}} {{ 'repairs.fittings.overrides.between' | translate }} {{ override.startTime }} - {{ override.endTime }}
                  </div>
                  <div class="col-md-2" style="text-align:end;">
                    <span class="fa hubtiger-delete" (click)="deleteOverride(override)" style="cursor:pointer; font-size:20px;"></span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="hasSpecificDay()">
                <div class="row col-md-12" style="margin-bottom:10px;">
                  <div class="col-md-10" style="display: flex; align-items: center; padding-left: 30px;">
                    {{ 'repairs.fittings.overrides.no_day_overrides' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-header">
            {{ 'repairs.fittings.overrides.date_overrides' | translate }}
          </div>
          <div class="row">
            <div style="width: -webkit-fill-available;">
              <div class="row" *ngFor="let override of configuredOverrides">
                <div class="row col-md-12" *ngIf="override.forSpecificDate" style="margin-bottom:10px;">
                  <div class="col-md-10" style="display: flex; align-items: center; padding-left: 30px;">
                    {{ 'repairs.fittings.overrides.available_on' | translate }} {{ override.specificDate}}  {{ 'repairs.fittings.overrides.between' | translate }} {{ override.startTime }} - {{ override.endTime }}
                  </div>
                  <div class="col-md-2" style="text-align:end;">
                    <span class="fa hubtiger-delete" (click)="deleteOverride(override)" style="cursor:pointer; font-size:20px;"></span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="hasSpecificDate()">
                <div class="row col-md-12">
                  <div class="col-md-10" style="display: flex; align-items: center; padding-left: 30px;">
                    {{ 'repairs.fittings.overrides.no_date_overrides' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog key="add_edit_services"></p-confirmDialog>
